import { el } from './dom.js';
import { initials, colorFor } from '../lib/names.js';

/** The signed-in member's avatar: their trtCRM photo, or their initials until (and unless) it loads. */

export function accountAvatar() {
  return el('div', {
    class: 'avatar is-loading',
    'aria-busy': 'true',
    'aria-label': 'Loading profile picture',
    role: 'img',
  });
}

/** The photo is the backend's same-origin copy (/auth/picture) or an https image URL; nothing else. */
export function validPicture(picture) {
  if (picture === '/auth/picture') return true;
  if (typeof picture !== 'string' || picture.length > 500) return false;
  try {
    return new URL(picture).protocol === 'https:';
  } catch {
    return false;
  }
}

/**
 * Fill `avatar` for `user` ({ name, picture }): initials at once, replaced by the photo when it loads.
 * A photo that fails to load (or is not allowed by the page's policy) leaves the initials.
 */
export function showAccountAvatar(avatar, user, { ImageCtor = globalThis.Image } = {}) {
  const name = user?.name ?? 'You';
  avatar.title = `Signed in as ${name}`;
  const ready = () => {
    avatar.classList.remove('is-loading');
    avatar.removeAttribute('aria-busy');
    avatar.setAttribute('aria-label', `Signed in as ${name}`);
  };
  avatar.textContent = initials(name);
  avatar.style.background = colorFor(name);
  ready();
  if (!validPicture(user?.picture) || !ImageCtor) return;
  const image = new ImageCtor();
  image.alt = '';
  image.referrerPolicy = 'no-referrer';
  image.onload = () => {
    image.onload = image.onerror = null;
    avatar.replaceChildren(image);
    avatar.style.background = '';
  };
  image.onerror = () => {
    image.onload = image.onerror = null;
  };
  image.src = user.picture;
}
